/**
 * @description
 * @author Kody
 * @date 2018-10-09
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

import IInput from './models/input';
import IOutput from './models/output';

export const createImage = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.CREATE_IMG, data);
};
